module.exports = __webpack_public_path__ + "static/media-gift-card-0edb976d0dfe60c38e8e67d58a0a5141.png";